import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import * as projectReducer from "containers/Project/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as businessReducer from "containers/Business/BusinessReducer";

import Strategy from "components/Business/Strategy/Strategy";
import NextStrategy from "components/Next/Strategy/Strategy";

class StrategyContainer extends React.PureComponent {
  render() {
    return this.props.isNext ? <NextStrategy {...this.props} /> : <Strategy {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = ownProps.id;

  return {
    initRun: () => {},
    updateDrilldownValue: (runId, drilldownValue) =>
      dispatch(projectReducer.updateDrilldownValue(id, runId, drilldownValue)),
    updateBusinessMode: (businessMode) => dispatch(businessReducer.updateBusinessMode(id, businessMode)),
    updateBusinessObjective: (runId, businessObjective) =>
      dispatch(setupReducer.updateBusinessObjective(id, runId, businessObjective)),
    updateIsRealityHammer: (runId, isRealityHammer) => {
      dispatch(setupReducer.updateIsRealityHammer(runId, isRealityHammer));
      dispatch(projectReducer.resetBudget(id));
    },
    updateScaledTotal: (runId, s) => dispatch(setupReducer.updateScaledTotal(id, runId, s)),

    updateOutcomePercentage: (runId, percentage) => {
      dispatch(projectReducer.updateOutcomePercentage(id, runId, percentage));
      dispatch(projectReducer.resetBudget(id));
    },

    updateConversionGain: (runId, conversionGain) => {
      dispatch(setupReducer.updateConversionGain(runId, conversionGain, undefined, undefined, id));
      if (id !== "new") {
        dispatch(projectReducer.resetBudget(id));
      }
    },
    updateConversionCost: (runId, conversionCost) => {
      dispatch(setupReducer.updateConversionCost(runId, conversionCost, undefined, undefined, id));
      if (id !== "new") {
        dispatch(projectReducer.resetBudget(id));
      }
    },
    updateConversionSaved: (runId, conversionSaved) => {
      dispatch(setupReducer.updateConversionSaved(runId, conversionSaved, undefined, undefined, id));
      if (id !== "new") {
        dispatch(projectReducer.resetBudget(id));
      }
    },
    updateConversionMissed: (runId, conversionMissed) => {
      dispatch(setupReducer.updateConversionMissed(runId, conversionMissed, undefined, undefined, id));
      if (id !== "new") {
        dispatch(projectReducer.resetBudget(id));
      }
    },
    updateShowImpact: (runId, showImpact) => dispatch(setupReducer.updateShowImpact(runId, showImpact)),
    updateCustomValue: (runId, blueprintId, valId, value) => {
      dispatch(setupReducer.updateCustomValue(runId, blueprintId, valId, value));
      dispatch(projectReducer.resetBudget(id));
    }
  };
};

const mapStateToProps = (state, ownProps) => {
  const id = ownProps.id;

  let optimized = ownProps.optimized;
  if (!optimized || optimized.id !== id) {
    optimized = projectReducer.getOptimized(state, id);
  }

  let modelGroups = ownProps.modelGroups;
  if (!modelGroups || modelGroups.id !== id) {
    modelGroups = projectReducer.getModelGroups(state, id);
  }

  const runId = optimized && optimized.innerId !== undefined ? optimized.innerId : id;

  const overallRunId = projectReducer.getOverallRunId(state, id);

  return {
    id: id,
    runId: runId,
    optimized: optimized,

    blueprint: setupReducer.getBlueprintFromSetup(state, runId),

    setup: setupReducer.getSetup(state, runId),
    overallSetup: setupReducer.getSetup(state, overallRunId),
    setupLabels: setupReducer.getSetupLabels(state, runId),

    project: projectReducer.getProject(state, id),
    modelGroups: modelGroups,
    isOverallSegment: projectReducer.getIsOverallSegment(state, id, runId),

    isRealityHammer: setupReducer.getIsRealityHammer(state, runId),
    hasLinkedProject: projectReducer.getHasLinkedProject(state, id),

    isContinuous: setupReducer.getIsContinuous(state, runId),
    revenueLabel: setupReducer.getAdvancedRevenueLabel(state, runId),
    profitLabel: setupReducer.getNetImpactLabel(state, runId),
    costLabel: setupReducer.getAdvancedCostLabel(state, runId),
    customMappings: setupReducer.getCustomMappings(state, runId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(StrategyContainer);
